/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Please_Wait_While_We_EstablishInputs */

const en_please_wait_while_we_establish = /** @type {(inputs: Please_Wait_While_We_EstablishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please wait while we establish a secure SSL connection and handshake with Vercel's edge network...`)
};

const es_please_wait_while_we_establish = /** @type {(inputs: Please_Wait_While_We_EstablishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Espera mientras establecemos una conexión SSL segura y un enlace con la red perimetral de Vercel...`)
};

const fr_please_wait_while_we_establish = /** @type {(inputs: Please_Wait_While_We_EstablishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez patienter pendant que nous établissons une connexion SSL sécurisée et un handshake avec le réseau périphérique de Vercel...`)
};

const de_please_wait_while_we_establish = /** @type {(inputs: Please_Wait_While_We_EstablishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte warte, während wir eine sichere SSL-Verbindung und einen Handshake mit dem Edge-Netzwerk von Vercel herstellen...`)
};

const ja_please_wait_while_we_establish = /** @type {(inputs: Please_Wait_While_We_EstablishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`安全なSSL接続とVercelのエッジネットワークとのハンドシェイクを確立しています。しばらくお待ちください...`)
};

const zh_please_wait_while_we_establish = /** @type {(inputs: Please_Wait_While_We_EstablishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请稍候，我们正在建立安全的 SSL 连接并与 Vercel 的边缘网络进行握手...`)
};

const ar_please_wait_while_we_establish = /** @type {(inputs: Please_Wait_While_We_EstablishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يرجى الانتظار بينما نؤسس اتصال SSL آمن ومصافحة مع شبكة الحافة الخاصة بـ Vercel...`)
};

const id_please_wait_while_we_establish = /** @type {(inputs: Please_Wait_While_We_EstablishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harap tunggu sementara kami membuat koneksi SSL yang aman dan berjabat tangan dengan jaringan edge Vercel...`)
};

const it_please_wait_while_we_establish = /** @type {(inputs: Please_Wait_While_We_EstablishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attendi mentre stabiliamo una connessione SSL sicura e un handshake con la rete edge di Vercel...`)
};

const ru_please_wait_while_we_establish = /** @type {(inputs: Please_Wait_While_We_EstablishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пожалуйста, подождите, пока мы устанавливаем защищенное SSL-соединение и рукопожатие с периферийной сетью Vercel...`)
};

const pt_please_wait_while_we_establish = /** @type {(inputs: Please_Wait_While_We_EstablishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aguarde enquanto estabelecemos uma conexão SSL segura e um handshake com a rede de borda (edge network) da Vercel...`)
};

const ko_please_wait_while_we_establish = /** @type {(inputs: Please_Wait_While_We_EstablishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`안전한 SSL 연결을 설정하고 Vercel의 에지 네트워크와 핸드셰이크를 수행하는 동안 잠시 기다려 주십시오...`)
};

/**
* | output |
* | --- |
* | "Please wait while we establish a secure SSL connection and handshake with Vercel's edge network..." |
*
* @param {Please_Wait_While_We_EstablishInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const please_wait_while_we_establish = /** @type {((inputs?: Please_Wait_While_We_EstablishInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Please_Wait_While_We_EstablishInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_please_wait_while_we_establish(inputs)
	if (locale === "es") return es_please_wait_while_we_establish(inputs)
	if (locale === "fr") return fr_please_wait_while_we_establish(inputs)
	if (locale === "de") return de_please_wait_while_we_establish(inputs)
	if (locale === "ja") return ja_please_wait_while_we_establish(inputs)
	if (locale === "zh") return zh_please_wait_while_we_establish(inputs)
	if (locale === "ar") return ar_please_wait_while_we_establish(inputs)
	if (locale === "id") return id_please_wait_while_we_establish(inputs)
	if (locale === "it") return it_please_wait_while_we_establish(inputs)
	if (locale === "ru") return ru_please_wait_while_we_establish(inputs)
	if (locale === "pt") return pt_please_wait_while_we_establish(inputs)
	return ko_please_wait_while_we_establish(inputs)
});